import {Component, ElementRef, inject, OnInit, ViewChild} from '@angular/core';
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {Observable, Subscription} from "rxjs";
import {PortalAwareness} from "../../../store/entities/system-configurations/portal-awareness/portal-awareness.model";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {
  GET_ALL_PORTAL_AWARENESS
} from "../../../store/entities/system-configurations/portal-awareness/portal-awareness.graphql";
import {environment} from "../../../../environments/environment";
import {VideoTypeChoices} from "../../../shared/components/video-player/video-player.component";
import {MediaImage} from "../../../store/entities/system-configurations/media-image/media-image.model";
import {systemName} from "../../../store/base.entity";
import {GET_MEDIA_IMAGES} from "../../../store/entities/system-configurations/media-image/media-image.graphql";

@Component({
  selector: 'app-guest-awareness',
  templateUrl: './guest-awareness.component.html',
  styleUrl: './guest-awareness.component.scss'
})
export class GuestAwarenessComponent implements OnInit {
  activeAwareness: boolean;
  store = inject(Store<AppState>)

  awarenessList: PortalAwareness[] = [];
  portalAwareness: PortalAwareness;
  activeIndex = 0;
  ellipticalValue= 400;
  subscriptions = new Subscription();
  protected readonly environment = environment;
  protected readonly VideoTypeChoices = VideoTypeChoices;

  sectorCarouselItems: any[] = []
  activeSectorCarouselItems: any[] = []
  activeSectorCarouselItemPage: number = 0

  carousels$: Observable<MediaImage[]>;
  // fileUrl = 'https://demo.services.gov.go.tz:9081/tgsd_file_media';

  lastShownSectorIndex: number = 0
  @ViewChild('prevBtn', {static: false}) prevBtn: ElementRef;
  @ViewChild('nextBtn', {static: false}) nextBtn: ElementRef;
  @ViewChild('parentSectorCarousel', {static: false}) parentSectorCarousel: ElementRef;
  @ViewChild('backToTop') backToTop: ElementRef;
  imageIndex = 0
  screenWidth: number;
  wrapper: number = 100

  activeCarouselImage: MediaImage
  private intervalId: any;

  baseUrl: string = environment.AUTH_SERVER_URL;

  mediaImages$: Observable<MediaImage[]>
  mediaImages: MediaImage[]

  readMore() {
    this.activeAwareness = !this.activeAwareness;
  }

  ngOnInit() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      query: GET_ALL_PORTAL_AWARENESS,
      entity: StoreItemEntity.portalAwareness,
      filtering: {},
    }));

    this.store.dispatch(StoreItemActions.getStoreItems({
      entity: StoreItemEntity.mediaImage,
      filtering: {},
      query: GET_MEDIA_IMAGES
    }))

    this.mediaImages$ = this.store.select(selectStoreItems(StoreItemEntity.mediaImage))
    this.mediaImages$.subscribe(data => {
      if (data?.length) {
        this.mediaImages = data
        this.nextSlide();
      }
    })

    this.subscriptions.add(
      this.store.select(selectStoreItems(StoreItemEntity.portalAwareness)).subscribe(d => {
          this.awarenessList = [{
            id: '0',
            title: 'Good Governance and Reform Management Information System',
            description: `The Good Governance and Reform Management Information System (${systemName}) operates as a comprehensive platform designed to support governance practices and reform management initiatives, particularly in alignment with NACSAP IV. It encompasses various components and functionalities to facilitate the collection, management, analysis, and dissemination of data related to governance and reform efforts`
          }, ...d];
          this.portalAwareness = this.awarenessList[this.activeIndex];
      })
    )


    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 2000);
  }

  nextSlide(): void {
    if (this.imageIndex < this.mediaImages.length - 1) {
      this.imageIndex++;
      this.activeCarouselImage = this.mediaImages[this.imageIndex];
    } else {
      this.imageIndex = 0;
      this.activeCarouselImage = this.mediaImages[this.imageIndex];
    }

  }

  prev() {

    this.wrapper = this.screenWidth - (this.prevBtn.nativeElement.offsetWidth * 2) - 10

    let totalItemWidths = 0
    let sectorCarouselCurrentPageCount = this.activeSectorCarouselItems.length
    this.activeSectorCarouselItems = []
    let items = this.sectorCarouselItems.slice()
    if (this.lastShownSectorIndex === this.sectorCarouselItems.length) {
      this.lastShownSectorIndex -= sectorCarouselCurrentPageCount
    }
    items = items.splice(0, this.lastShownSectorIndex)

    for (let i = items.length - 1; i >= 0; i--) {
      let width = (items[i].sectorName.length * 9) + 32 + 10
      if (this.wrapper > totalItemWidths + width) {
        totalItemWidths += width
        this.activeSectorCarouselItems.push(items[i])
        this.lastShownSectorIndex -= 1
      } else {
        break
      }
    }
    this.activeSectorCarouselItems.reverse()
    this.activeSectorCarouselItemPage -= 1
  }

  nextOrPrevAwareness(index: number) {
    if (this.awarenessList[index]) this.activeIndex = index;
    if (this.activeIndex > -1) this.portalAwareness = this.awarenessList[this.activeIndex];
  }
}
